// Custom hook for Quick Actions functionality
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@config/constants';

export interface UseQuickActionsReturn {
  handleUpload: () => void;
  handleNewFolder: () => void;
  handleOpenExplorer: () => void;
}

export const useQuickActions = (): UseQuickActionsReturn => {
  const navigate = useNavigate();

  const handleUpload = () => {
    navigate(ROUTES.CLOUD_EXPLORER, { state: { openUpload: true } });
  };

  const handleNewFolder = () => {
    navigate(ROUTES.CLOUD_EXPLORER, { state: { openCreateFolder: true } });
  };

  const handleOpenExplorer = () => {
    navigate(ROUTES.CLOUD_EXPLORER);
  };

  return {
    handleUpload,
    handleNewFolder,
    handleOpenExplorer,
  };
};
